import { lazy } from "react";

import Spin from "core/ui-kit/spin";

import withSuspenseHoc from "core/HOCs/withSuspense";

import ROUTES from "core/constants/routes/routes";

const ProjectsContainer = withSuspenseHoc(lazy(() => import("./projectsContainer")), <Spin />);

import { PERMISSION_ACTION, PERMISSION_RESOURCE } from "core/constants/permission";

const ProjectsNewPageRoute = {
    path: ROUTES.PROJECTS,
    element: ProjectsContainer,
    permission: { resource: PERMISSION_RESOURCE.PROJECT, action: PERMISSION_ACTION.VIEW }
};

export default ProjectsNewPageRoute;